<div [hidden]="!active" [routerLink]="tabRouterLink" routerLinkActive [routerLinkActiveOptions]="{ paths: 'exact', matrixParams: 'exact', fragment: 'exact', queryParams: 'ignored' }" #rla="routerLinkActive">
  <ng-content></ng-content>
  <ng-container
    *ngIf="template"
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{ data: dataContext }"
  ></ng-container>
</div>
